// O edital escolhido precede a criaÃ§Ã£o da Inscricao no backend, entÃ£o nÃ£o hÃ¡ de onde
// recarregÃ¡-lo depois de um F5 â fica no localStorage atÃ© virar inscriÃ§Ã£o de verdade.
const EDITAL_ESCOLHIDO_KEY = 'editalEscolhido';

function persistirEditalEscolhido(editalId) {
    if (editalId) localStorage.setItem(EDITAL_ESCOLHIDO_KEY, editalId);
    else localStorage.removeItem(EDITAL_ESCOLHIDO_KEY);
}

export default {
    // --- UsuÃ¡rio / SessÃ£o ---
    SET_USUARIO(state, {
        id, nome, email, isAdmin, trocarSenha, perfis, cpf, crm, candidatoId,
    }) {
        state.usuario = {
            id: id || '',
            nome,
            email,
            isAdmin: !!isAdmin,
            trocarSenha: !!trocarSenha,
            perfis: perfis || [],
            cpf: cpf || '',
            crm: crm || '',
            candidatoId: candidatoId ? Number(candidatoId) : null,
        };
    },

    SET_TROCAR_SENHA(state, trocarSenha) {
        state.usuario.trocarSenha = !!trocarSenha;
    },

    LIMPAR_USUARIO(state) {
        state.usuario = {
            id: '', nome: '', email: '', isAdmin: false, trocarSenha: false, perfis: [], cpf: '', crm: '', candidatoId: null,
        };
    },

    // --- PaginaÃ§Ã£o ---
    SET_PAGINATION(state, pagination) {
        state.pagination = { ...state.pagination, ...pagination };
    },

    // --- InscriÃ§Ã£o do candidato ---
    SET_EDITAL_ESCOLHIDO(state, editalId) {
        const id = editalId ? Number(editalId) : null;
        persistirEditalEscolhido(id);
        state.minhaInscricao = { ...state.minhaInscricao, editalId: id };
    },

    SET_ACEITE_TERMOS(state, aceiteTermos) {
        state.minhaInscricao = { ...state.minhaInscricao, aceiteTermos };
    },

    SET_ETAPA_INSCRICAO(state, { etapa, dados }) {
        state.minhaInscricao = { ...state.minhaInscricao, [etapa]: dados };
    },

    SET_ETAPA_ATUAL(state, etapaAtual) {
        state.minhaInscricao = { ...state.minhaInscricao, etapaAtual };
    },

    SET_INSCRICAO_ATUAL(state, { id, protocolo, vagaId }) {
        state.minhaInscricao = {
            ...state.minhaInscricao,
            inscricaoId: id,
            protocolo,
            vagaId: vagaId ?? state.minhaInscricao.vagaId,
        };
    },

    SET_CONTEXTO_INSCRICAO(state, inscricao) {
        const editalId = inscricao ? inscricao.editalId : state.minhaInscricao.editalId;
        persistirEditalEscolhido(editalId);
        state.minhaInscricao = {
            ...state.minhaInscricao,
            carregada: true,
            editalId,
            inscricaoId: inscricao ? inscricao.id : null,
            vagaId: inscricao ? inscricao.vagaId : null,
            protocolo: inscricao ? inscricao.protocolo : '',
            aceiteTermos: !!(inscricao && inscricao.aceiteTermo),
            etapaProcesso: inscricao ? inscricao.etapaAtual : null,
            pagamento: inscricao ? inscricao.pagamento : null,
            revisaoPrimeiraEtapaSolicitada: inscricao ? !!inscricao.revisaoPrimeiraEtapaSolicitada : false,
            revisaoPrimeiraEtapaJustificativa: inscricao ? (inscricao.revisaoPrimeiraEtapaJustificativa || '') : '',
        };
    },

    LIMPAR_CONTEXTO_INSCRICAO(state) {
        persistirEditalEscolhido(null);
        state.minhaInscricao = {
            ...state.minhaInscricao,
            carregada: false,
            editalId: null,
            inscricaoId: null,
            vagaId: null,
            protocolo: '',
            aceiteTermos: false,
            etapaProcesso: null,
            pagamento: null,
            revisaoPrimeiraEtapaSolicitada: false,
            revisaoPrimeiraEtapaJustificativa: '',
        };
    },

    SET_DOCUMENTO_ANEXADO(state, { tipoId, anexo }) {
        state.minhaInscricao = {
            ...state.minhaInscricao,
            documentos: { ...state.minhaInscricao.documentos, [tipoId]: anexo },
        };
    },

    EXCLUIR_DOCUMENTO_ANEXADO(state, tipoId) {
        const documentos = { ...state.minhaInscricao.documentos };
        delete documentos[tipoId];
        state.minhaInscricao = { ...state.minhaInscricao, documentos };
    },

    SET_PAGAMENTO(state, pagamento) {
        state.minhaInscricao = { ...state.minhaInscricao, pagamento };
    },

    SET_DOCUMENTOS_EXIGIDOS(state, documentosExigidos) {
        state.documentosExigidos = documentosExigidos;
    },

    // --- Indicadores ---
    SET_INDICADORES(state, indicadores) {
        state.indicadores = indicadores;
    },

    // --- InscriÃ§Ãµes ---
    SET_INSCRICOES(state, inscricoes) {
        state.listaInscricoes = inscricoes;
    },

    ATUALIZAR_INSCRICAO(state, inscricaoAtualizada) {
        const index = state.listaInscricoes.findIndex((item) => item.id === inscricaoAtualizada.id
            || String(item.id) === String(inscricaoAtualizada.id));
        if (index === -1) {
            state.listaInscricoes = [...state.listaInscricoes, inscricaoAtualizada];
            return;
        }
        state.listaInscricoes.splice(index, 1, {
            ...state.listaInscricoes[index],
            ...inscricaoAtualizada,
            // Nunca deixar o histÃ³rico sumir se a atualizaÃ§Ã£o vier sem a lista
            pareceres: inscricaoAtualizada.pareceres !== undefined
                ? inscricaoAtualizada.pareceres
                : state.listaInscricoes[index].pareceres,
        });
    },

    // --- Editais ---
    SET_EDITAIS(state, editais) {
        state.listaEditais = editais;
    },

    ADICIONAR_EDITAL(state, edital) {
        state.listaEditais = [...state.listaEditais, edital];
    },

    ATUALIZAR_EDITAL(state, editalAtualizado) {
        const index = state.listaEditais.findIndex((item) => item.id === editalAtualizado.id);
        if (index === -1) return;
        state.listaEditais.splice(index, 1, { ...state.listaEditais[index], ...editalAtualizado });
    },

    EXCLUIR_EDITAL(state, id) {
        state.listaEditais = state.listaEditais.filter((item) => item.id !== id);
    },

    // --- Cadastros ---
    SET_TIPOS_DOCUMENTO(state, tiposDocumento) {
        state.listaTiposDocumento = tiposDocumento;
    },

    SET_CATALOGO_TIPOS_DOCUMENTO(state, tiposDocumento) {
        state.catalogoTiposDocumento = tiposDocumento;
    },

    ADICIONAR_TIPO_DOCUMENTO(state, tipoDocumento) {
        state.catalogoTiposDocumento.push(tipoDocumento);
    },

    ATUALIZAR_TIPO_DOCUMENTO(state, tipoDocumentoAtualizado) {
        const index = state.catalogoTiposDocumento.findIndex((item) => item.id === tipoDocumentoAtualizado.id);
        if (index === -1) return;
        state.catalogoTiposDocumento.splice(index, 1, {
            ...state.catalogoTiposDocumento[index],
            ...tipoDocumentoAtualizado,
        });
    },

    SET_ESPECIALIDADES(state, especialidades) {
        state.listaEspecialidades = especialidades;
    },

    SET_AREAS_ATUACAO(state, areasAtuacao) {
        state.listaAreasAtuacao = areasAtuacao;
    },

    // --- UsuÃ¡rios ---
    SET_USUARIOS(state, usuarios) {
        state.listaUsuarios = usuarios;
    },

    ADICIONAR_USUARIO(state, usuario) {
        state.listaUsuarios.push(usuario);
    },

    ATUALIZAR_USUARIO(state, usuarioAtualizado) {
        const index = state.listaUsuarios.findIndex((item) => item.id === usuarioAtualizado.id);
        if (index === -1) return;
        state.listaUsuarios.splice(index, 1, { ...state.listaUsuarios[index], ...usuarioAtualizado });
    },

    // --- Pagamentos ---
    SET_PAGAMENTOS(state, pagamentos) {
        state.listaPagamentos = pagamentos;
    },

    ATUALIZAR_STATUS_PAGAMENTO(state, { inscricaoId, situacao }) {
        const pagamento = state.listaPagamentos.find((item) => item.id === inscricaoId);
        if (!pagamento) return;
        pagamento.pagamento.situacao = situacao;
    },
};
